// extracted by mini-css-extract-plugin
export default {"svgIcon":"svgIcon_svgIcon__hENj5"};